import en from './en.json'
import fa from './fa.json'
import ar from './ar.json'

export default {
    en,
    fa,
    ar
}